<button pButton pRipple 
    type="button" 
    icon="fas fa-arrow-left" 
    class="p-button-rounded p-button-text p-button-plain fw-bold text-dark my-0"
    (click)="onClick()">
    <span>
        {{ l('::GoBack') }}
    </span>
</button>